"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnypointRedirectURIs = useAnypointRedirectURIs;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _url = require("url");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var API_NOTEBOOK_REDIRECT_URI = 'https://api-notebook.anypoint.mulesoft.com/authenticate/oauth.html';
var OAUTH_POPUP_PATH = '/oauthCallback.html';
function useAnypointRedirectURIs() {
  var config = (0, _exchangeReactHooks.useConfig)();
  var anypointRedirectURIs = [API_NOTEBOOK_REDIRECT_URI, (0, _url.format)(_objectSpread(_objectSpread({}, config.externalURI), {}, {
    pathname: "".concat(config.externalURI.pathname).concat(OAUTH_POPUP_PATH)
  }))];
  return anypointRedirectURIs;
}
//# sourceMappingURL=hooks.js.map